import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { AuthService } from '@cavo-admin/auth';

@Component({
	selector: 'cavo-admin-login',
	template: '',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
	private authService = inject(AuthService);

	ngOnInit(): void {
		this.authService.login();
	}
}
